// Add data-attributes to add and remove positions to/from returnsorder

import api from 'poly-eshop4/eshop/ui/js/container';
import { load } from 'poly-eshop4/eshop/ui/js/util';

$(document).on('submit.addReturnsOrderPosition', '[data-add-returnsorder-position]', function(event) {
  event.preventDefault();
  const $this = $(this);
  const $form = $this.closest('form');
  const $reveal = $this.closest('.reveal');

  const data = $form.serializeArray();
  const qty = $this.closest('[data-add-cart]').find('input[name=quantity]').val();
  if ($(`[data-bind-html="returnsorder:html"]`).length) {
    data.push({ name: 'render', value: 1 });
    data.push({ name: 'calculate', value: 1 });
  } else if (qty) {
    data.push({ name: 'quantity', value: qty });
  }

  return load(
    $reveal,
    $.stores.returnsorder.post($form.attr('action'), data).then(() => {
      if ($reveal.length) {
        setTimeout(() => $reveal.foundation('close'), 1000);
      }
    }),
  );
});

$(document).on('submit.removeReturnsOrderPositions', '[data-remove-returnsorder-positions]', function(event) {
  event.preventDefault();

  const $form = $(this).closest('form');
  const data = $form.serializeArray();

  $('[data-container-position-editmode]:checked').each((idx, input) => {
    data.push({ name: 'position_id', value: input.value });
  });

  if ($('[data-bind-html="returnsorder:html"]').length) {
    data.push({ name: 'render', value: 1 });
    data.push({ name: 'calculate', value: 1 });
  }

  load(
    this,
    $.stores.returnsorder.post($form.attr('action'), data),
  ).then((result) => {
    if (result.container.position_count === 0) {
      $(this).closest('.position-container').removeClass('position-container--editmode');
      $('[data-container-editmode]').addClass('hide');
    }
  });
});

$(document).on('submit.copyReturnsOrderPositions', '[data-copy-returnsorder-positions]', function(event) {
  event.preventDefault();
  api.copyPositions($(this), 'returnsorder');
});

$(document).on('submit', '[data-update-returnsorder-position]', function(event) {
  event.preventDefault();
  const $this = $(this);
  const $reveal = $this.closest('.reveal');
  const $form = $this.closest('form');
  const data = $form.serializeArray();
  if ($(`[data-bind-html="returnsorder:html"]`).length) {
    data.push({ name: 'render', value: 1 });
    data.push({ name: 'calculate', value: 1 });
  }
  $this.get(0).defaultValue = $this.val();
  $reveal.addClass('loading');
  $.stores.returnsorder.post($form.attr('action'), data).then(() => {
    $reveal.foundation('close');
    $reveal.remove();
  });
});

$(document).on('submit', '[data-update-returnsorder-position-text]', event => event.preventDefault());
$(document).on('change', '[data-update-returnsorder-position-text]', function(event) {
  event.preventDefault();
  api.setPositionText($(this), 'returnsorder');
});

$(document).on('submit', '[data-remove-returnsorder-position]', function(event) {
  event.preventDefault();
  api.removePosition($(this), 'returnsorder');
});

$(document).on('submit', '[data-clear-returnsorder]', function(event) {
  event.preventDefault();
  api.clear($(this), 'returnsorder');
});
